// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__pOB8L","formControl":"addForm_formControl__CuCon","list":"addForm_list__C1PRx","btnWrpper":"addForm_btnWrpper__xLxOT"};